module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"detail":"詳細","buy_now":"今すぐ購入"}}')
  delete Component.options._Ctor
}
